<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :mobile-breakpoint="768"
      app
    >
      <v-img
      class="pa-4"
        src="@/assets/background.jpg"
        height="170"
        gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h5 white--text">
              {{ $store.state.appTitle }}
            </v-list-item-title>
            <v-list-item-subtitle class="white--text">
              Your busy life deserves this.
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-img>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.to"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="primary"
      dark
      src="@/assets/background.jpg"
      prominent
      :height="$route.path === '/' ? '236' : '170'"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(19,84,122,.8), rgba(128,208,199,.9)"
        ></v-img>
      </template>

      <v-container class="header-container pa-0">
        <v-row>
          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <v-spacer></v-spacer>
          <Search />
        </v-row>
        <v-row>
          <v-toolbar-title class="ml-4 text-h4">{{ $store.state.appTitle }}</v-toolbar-title>
        </v-row>
        <v-row>
          <LiveDateTime />
        </v-row>
        <v-row v-if="$route.path === '/'">
          <FieldAddTask />
        </v-row>
      </v-container>

    </v-app-bar>

    <v-main>
      <router-view></router-view>
      <Snackbar />
    </v-main>
  </v-app>
</template>

<script>
import FieldAddTask from '@/components/Todo/FieldAddTask'
import Snackbar from '@/components/Global/Snackbar'
import Search from '@/components/Tools/Search'
import LiveDateTime from '@/components/Tools/LiveDateTime'

export default {
  components: {
    FieldAddTask,
    Snackbar,
    Search,
    LiveDateTime
  },
  data() {
    return {
      drawer: null,
      items: [
        { title: 'Todo', icon: 'mdi-format-list-checks', to: '/' },
        { title: 'About', icon: 'mdi-help-box', to: '/about' },
      ],
    }
  },
  mounted() {
    this.$store.dispatch('getTasks')
  }
}
</script>

<style lang="scss" scoped>
.header-container {
  max-width: none !important;
}
</style>